/**
 * Going home from the game.
 *
 * The game is one Phaser instance holding one room; the cleanest way to
 * leave it is a fresh page. A flag in sessionStorage — this tab only, gone
 * with it — tells the next load to open the roster instead of jumping back
 * into the character whose session is still stored.
 */
const HOME_KEY = 'shefira.home';

export function requestHome(): void {
  try {
    sessionStorage.setItem(HOME_KEY, '1');
  } catch {
    /* without storage the reload simply resumes the game */
  }
  window.location.reload();
}

/** True once, on the load that follows `requestHome()`. */
export function consumeHomeRequest(): boolean {
  try {
    const wanted = sessionStorage.getItem(HOME_KEY) === '1';
    sessionStorage.removeItem(HOME_KEY);
    return wanted;
  } catch {
    return false;
  }
}
